import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppSettings } from 'src/app/core/shared';

@Component({
    selector: 'app-smart-care-section',
    templateUrl: './smart-care-section.component.html',
    styleUrls: ['./smart-care-section.component.scss'],
    standalone: false
})

export class SmartCareSectionComponent implements OnInit {

  public smartCareModel: UntypedFormGroup;
  public submitted = false;
  private window:Window = window;

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initSmartCareModelForm();
  }

  initSmartCareModelForm() {
    this.smartCareModel = this.fb.group({
      vrn: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(10)]],
      postCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(8)]]
    });
  }

  get getErrors() {
    return {
      vrnErrors: this.smartCareModel.controls.vrn.errors,
      postCodeErrors: this.smartCareModel.controls.postCode.errors
    };
  }

  redirectToSmartCare(): void {
    this.submitted = true;
    if (this.smartCareModel.invalid) {
      return;
    }
    const params = `&vrn=${this.smartCareModel.value.vrn || ''}&postcode=${this.smartCareModel.value.postCode || ''}`;
    this.window.location.href = AppSettings.API_SMARTCARE_BASEURL + params;
  }
}
